import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { TdMediaService, TdPagingBarComponent, IPageChangeEvent } from '@covalent/core';
import { SearchInputComponent } from '../search-input/search-input.component';
import { SecurityService } from '../../security/security.service';
import { Action } from 'rxjs/scheduler/Action';

export const DECIMAL_FORMAT: (v: any) => any = (v: number) => v.toFixed(2);

export interface IColumn {
  name: string;
  label: string;
  numeric: boolean;
  format: any;
}

export interface Page {
  pageIndex: number;
  pageSize: number;
}

export enum Actions {
  view = 1 ,
  edit = 2,
  delete = 3
}

export interface ActionList {
  element: Actions;
  permission: string;
}

export class HasAction {
  public hasAction = false;
  public actions: ActionList[];
}

@Component({
  selector: 'app-generic-list',
  templateUrl: './generic-list.component.html',
  styleUrls: ['./generic-list.component.scss']
})
export class GenericListComponent implements OnInit, AfterViewInit {

  @Input() columns: IColumn[];
  @Input() rows: any[];
  @Input() searchTittle: string;
  @Input() searchPlaceHolder: string;
  @Input() isLoading = false;
  @Input() hasActions: HasAction;
  @Input() totalItems: number;
  @Input() hasActiveFilters = false;
  @Input() pageSize = 10;
  @Input() messageEmpty = 'No se encuentran elementos.';
  @Input() messageFilters = 'No se encuentran elementos que coincidan con el criterio de búsqueda actual.';

  @Input() securityService: SecurityService;

  @Output() change = new EventEmitter<Page>();
  @Output() search = new EventEmitter<string>();
  @Output() view = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() initialized = new EventEmitter();
  @Output() onClearSearch = new EventEmitter();

  public actions: any[];

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  constructor() { }

  ngOnInit() {

    this.actions = new Array();

    if (this.hasActions.hasAction) {
      for (const action of this.hasActions.actions) {
        switch (action.element) {
          case Actions.view:
            this.actions.push({ 'permission': action.permission, 'method': 'onView', 'icon': 'visibility', 'tooltip': 'Ver detalle' });
            break;
          case Actions.edit:
            this.actions.push({ 'permission': action.permission, 'method': 'onEdit', 'icon': 'edit', 'tooltip': 'Editar elemento' });
            break;
          case Actions.delete:
            this.actions.push({ 'permission': action.permission, 'method': 'onDelete', 'icon': 'delete_outline', 'tooltip': 'Eliminar elemento' });
            break;
        }
      }
    }

  }

  ngAfterViewInit() {
    this.initialized.emit();
  }

  onPageChange(page: Page) {
    this.change.emit(page);
  }

  onSearch(filter: string) {
    this.search.emit(filter);
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
    this.onClearSearch.emit();
  }

  onView(e) {
    this.view.emit(e);
  }

  onEdit(e) {
    this.edit.emit(e);
  }

  onDelete(e) {
    this.delete.emit(e);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/generic-list/generic-list.component.ts